import { Button, Drawer, Classes } from "@blueprintjs/core"
import { useState } from "react"
import { useDashboardsQuery, useDeleteDashboardMutation } from "../hooks/useDashboardQueries"
import { useQueryProfile } from "../../../hooks/useQueryProfile"
import { Dashboard } from "../types/dashboard"
import { DashboardTreeView } from "./DashboardTreeView"

interface DashboardSelectProps {
  onSelect: (dashboard: Dashboard | null) => void
  currentDashboard: Dashboard | null
}

export function DashboardSelect({ onSelect, currentDashboard }: DashboardSelectProps) {
  const { dashboards } = useDashboardsQuery()
  const { data: profile } = useQueryProfile()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const { mutate: deleteDashboard } = useDeleteDashboardMutation()

  const handleDelete = (dashboardId: number) => {
    deleteDashboard(dashboardId)
  }

  const handleSelect = (dashboard: Dashboard) => {
    onSelect(dashboard)
    setIsDrawerOpen(false)
  }

  return (
    <>
      <Button
        icon="dashboard"
        onClick={() => setIsDrawerOpen(true)}
        text={currentDashboard?.name || "Select Dashboard"}
        rightIcon="caret-down"
      />

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Dashboards"
        size="350px"
        icon="folder-open"
        position="left"
        className="bp5-dark"
      >
        <div className={Classes.DRAWER_BODY} style={{ padding: 0 }}>
          <DashboardTreeView
            dashboards={dashboards || []}
            currentDashboard={currentDashboard}
            onSelect={handleSelect}
            onDelete={handleDelete}
            currentUsername={profile?.username || ""}
            onClose={() => setIsDrawerOpen(false)}
          />
        </div>
      </Drawer>
    </>
  )
}
